import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { useNavigate } from 'react-router-dom'

// Add interface for the auth state
interface AuthState {
  returnUrl: string
}

function CallbackSignIn() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.isAuthenticated) {
      const user = auth.user as { state?: AuthState }
      const redirectPath = user?.state?.returnUrl || '/'
      navigate(redirectPath)
    }

    if (!auth.isLoading && !auth.isAuthenticated) {
      auth.signinRedirect().catch(error => {
        console.error('Sign-in error:', error)
        navigate('/', {
          state: { error: 'Authentication failed. Please try again.' },
        })
      })
    }
  }, [auth, navigate])

  return (
    <div className="flex items-center justify-center h-screen text-lg font-extralight">
      Processing login...
    </div>
  )
}

export { CallbackSignIn }
